// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Footer_footer__EwVYi {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 100;
  opacity: 0;
  transition: transform 0.3s ease, opacity 0.3s ease;
}

.Footer_footer__EwVYi.Footer_show__k3A9v {
  transform: translateY(0);
  opacity: 1;
}

.Footer_footer__EwVYi:not(.Footer_show__k3A9v) {
  transform: translateY(100%);
  opacity: 0;
}

.Footer_footerContent__E5RXg {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  padding: 0 20px;
}

.Footer_footerText__y-wf5 {
  color: #999;
  font-size: 12px;
}

.Footer_footerCenter__jiAEO {
  text-align: center;
  flex-grow: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Footer_footerLink__xVufR {
  color: #999;
  text-decoration: none;
  font-size: 12px;
  transition: color 0.3s;
  margin: 0 5px;
}

.Footer_footerLink__xVufR:hover {
  color: #eee;
}

.Footer_footerSeparator__dqaqI {
  color: #999;
  font-size: 12px;
  margin: 0 5px;
}

.Footer_footerLeft__N9RbZ {
  text-align: left;
}

.Footer_footerRight__gaJVT {
  text-align: right;
  display: flex;
  align-items: center;
}

.Footer_socialLink__8n4SS {
  color: #999;
  text-decoration: none;
  margin-left: 15px;
  font-size: 14px;
  transition: color 0.3s;
}

.Footer_socialLink__8n4SS:hover {
  color: #eee;
}

@media (max-width: 768px) {
  .Footer_footerText__y-wf5,
  .Footer_footerLink__xVufR,
  .Footer_footerSeparator__dqaqI {
    font-size: 10px;
  }

  .Footer_socialLink__8n4SS {
    font-size: 16px;
  }
}

@media (max-width: 576px) {
  .Footer_footerText__y-wf5,
  .Footer_footerLink__xVufR,
  .Footer_footerSeparator__dqaqI {
    font-size: 8px;
  }

  .Footer_socialLink__8n4SS {
    font-size: 14px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Footer.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,oCAAoC;EACpC,YAAY;EACZ,UAAU;EACV,kDAAkD;AACpD;;AAEA;EACE,wBAAwB;EACxB,UAAU;AACZ;;AAEA;EACE,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,iBAAiB;EACjB,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE;;;IAGE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;;;IAGE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".footer {\n  position: fixed;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  background-color: rgba(0, 0, 0, 0.8);\n  z-index: 100;\n  opacity: 0;\n  transition: transform 0.3s ease, opacity 0.3s ease;\n}\n\n.footer.show {\n  transform: translateY(0);\n  opacity: 1;\n}\n\n.footer:not(.show) {\n  transform: translateY(100%);\n  opacity: 0;\n}\n\n.footerContent {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin: 0 auto;\n  padding: 0 20px;\n}\n\n.footerText {\n  color: #999;\n  font-size: 12px;\n}\n\n.footerCenter {\n  text-align: center;\n  flex-grow: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.footerLink {\n  color: #999;\n  text-decoration: none;\n  font-size: 12px;\n  transition: color 0.3s;\n  margin: 0 5px;\n}\n\n.footerLink:hover {\n  color: #eee;\n}\n\n.footerSeparator {\n  color: #999;\n  font-size: 12px;\n  margin: 0 5px;\n}\n\n.footerLeft {\n  text-align: left;\n}\n\n.footerRight {\n  text-align: right;\n  display: flex;\n  align-items: center;\n}\n\n.socialLink {\n  color: #999;\n  text-decoration: none;\n  margin-left: 15px;\n  font-size: 14px;\n  transition: color 0.3s;\n}\n\n.socialLink:hover {\n  color: #eee;\n}\n\n@media (max-width: 768px) {\n  .footerText,\n  .footerLink,\n  .footerSeparator {\n    font-size: 10px;\n  }\n\n  .socialLink {\n    font-size: 16px;\n  }\n}\n\n@media (max-width: 576px) {\n  .footerText,\n  .footerLink,\n  .footerSeparator {\n    font-size: 8px;\n  }\n\n  .socialLink {\n    font-size: 14px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"footer": `Footer_footer__EwVYi`,
	"show": `Footer_show__k3A9v`,
	"footerContent": `Footer_footerContent__E5RXg`,
	"footerText": `Footer_footerText__y-wf5`,
	"footerCenter": `Footer_footerCenter__jiAEO`,
	"footerLink": `Footer_footerLink__xVufR`,
	"footerSeparator": `Footer_footerSeparator__dqaqI`,
	"footerLeft": `Footer_footerLeft__N9RbZ`,
	"footerRight": `Footer_footerRight__gaJVT`,
	"socialLink": `Footer_socialLink__8n4SS`
};
export default ___CSS_LOADER_EXPORT___;
